import {
  calculateEndDateMonthsForOneTimePledge,
  pledgeOneTimeFrequency,
} from 'donor-elf-web/lib/pledge-utils';
import Model, { attr } from '@ember-data/model';

export default class JournalDecisionChangeModel extends Model {
  // from the JournalContactModel
  @attr('string') journalContactId;

  // from the JournalDecisionModel
  @attr('string') journalDecisionId;
  @attr('string') journalDecisionJournalGoalId;
  @attr('date-only') journalDecisionDecisionDate;
  @attr('boolean') journalDecisionYesNo;
  @attr('boolean') journalDecisionPledgeIncreased;
  @attr('string') journalDecisionPrevPledgeId; // not from journalDecision. Only used for saving
  // intentionally not adding journalDecisionPrevPledgeInfo

  // from the PledgeModel
  @attr('string') pledgeId; // blank if new pledge
  @attr('number') pledgeAmount;
  @attr('number') pledgeFrequency;
  @attr('date-only') pledgeStartDate;
  @attr('date-only') pledgeEndDate;
  @attr('number') pledgeEndDateMonths;

  // When changing decision from yes to no or none, should the pledge be deleted?
  @attr('boolean') deletePledge;

  @attr('boolean') decisionMade;

  populateFromModels({ journalContact, journalDecision, pledge }) {
    if (journalContact) {
      this.journalContactId = journalContact.id;
    }
    this.decisionMade = journalDecision != null;
    if (journalDecision) {
      this.journalDecisionId = journalDecision.id;
      this.journalDecisionJournalGoalId = journalDecision.journalGoalId;
      this.journalDecisionDecisionDate = journalDecision.decisionDate;
      this.journalDecisionYesNo = journalDecision.yesNo;
      this.journalDecisionPledgeIncreased = journalDecision.pledgeIncreased;
    }
    if (pledge) {
      this.pledgeId = pledge.id;
      this.pledgeFrequency = pledge.frequency;
      this.pledgeStartDate = pledge.startDate;
      this.pledgeEndDate = pledge.endDate;
      this.pledgeAmount = pledge.amount;
      if (this.pledgeFrequency === pledgeOneTimeFrequency) {
        this.pledgeEndDateMonths = calculateEndDateMonthsForOneTimePledge({
          startDate: this.pledgeStartDate,
          endDate: this.pledgeEndDate,
        });
      }
    }
    this.deletePledge = false;
  }
}
